module.exports = __webpack_public_path__ + "img/consultation_a.f519f1ad.png";